import axios from 'axios';

export const heimdallInstance = axios.create({
  baseURL: process.env?.REACT_APP_HEIMDALL_HOST,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
